import { render, staticRenderFns } from "./pnldim10.vue?vue&type=template&id=2761412b&scoped=true"
import script from "./pnldim10.vue?vue&type=script&lang=js"
export * from "./pnldim10.vue?vue&type=script&lang=js"
import style0 from "./pnldim10.vue?vue&type=style&index=0&id=2761412b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2761412b",
  null
  
)

export default component.exports